import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/multiSession/user.multiSession.mutation.gql"
import type {
  UserMultiSessionMutation,
  UserMultiSessionMutationVariables,
} from "@/v2-backoffice-client/user/multiSession/__types__/user.multiSession.mutation"

type Options = MutationHookOptions<
  UserMultiSessionMutation,
  UserMultiSessionMutationVariables
>

export function useUserMultiSessionMutation(options?: Options) {
  return useMutation<
    UserMultiSessionMutation,
    UserMultiSessionMutationVariables
  >(mutation, options)
}
